module.exports = __webpack_public_path__ + "img/dennis.6165cf3f.jpg";